import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Ribbon from '../Ribbon';


const propTypes = {
    isTopRated: PropTypes.bool,
    variant: PropTypes.oneOf([
        'desktop',
        'mobile',
    ]),
};

const defaultProps = {
    isTopRated: false,
    variant: 'desktop',
};

const TopRatedIndividualTileLabel = ({classes, isTopRated, variant}) => {
    if (!isTopRated) return null;

    const label = `Top Rated ${moment().format('YYYY')}`;

    if (variant === 'mobile') {
        return (
            <div className='py-1 px-0 bg-mint-green -mx-2 mt-0 mb-2 w-[calc(100%+16px)] flex flex-wrap box-border justify-center'>
                <p className='text-white text-[1.1rem] leading-[1.5] m-0'>
                    {label}
                </p>
            </div>
        );
    }

    return <Ribbon label={label}/>;
};

TopRatedIndividualTileLabel.propTypes = propTypes;
TopRatedIndividualTileLabel.defaultProps = defaultProps;

export default TopRatedIndividualTileLabel;
